<template>
  <div class="flex flex-col gap-1 p-2">
    <div
      v-for="i in 4"
      :key="i"
      class="flex items-center gap-3 px-3 py-2.5 rounded-lg"
    >
      <div class="w-10 h-10 rounded-md bg-base-300 animate-pulse shrink-0" />
      <div class="flex flex-col gap-1.5 flex-1 min-w-0">
        <div
          :style="{ width: `${55 + (i * 13) % 30}%` }"
          class="h-3.5 rounded bg-base-300 animate-pulse"
        />
        <div
          :style="{ width: `${30 + (i * 7) % 20}%` }"
          class="h-2.5 rounded bg-base-200 animate-pulse"
        />
      </div>
    </div>
  </div>
</template>
